// Generic AJAX utilities
import $ from 'jquery'

function getCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content
}

export function postJson(url, data, successCallback, errorCallback) {
  const csrfToken = getCsrfToken()
  
  $.ajax({
    type: "POST",
    url: url,
    dataType: "json",
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(data),
    headers: {
      'X-CSRF-Token': csrfToken
    },
    success: successCallback,
    error: errorCallback,
  });
}

export function getJson(url, successCallback, errorCallback) {
  $.ajax({
    type: "GET",
    url: url,
    dataType: "json",
    success: successCallback,
    error: errorCallback,
  });
}
